import { z } from 'zod'
import { uuid } from './comum.js'

/**
 * A referência de FICHA: o registro que um nome leva a abrir (item 09 do lote de 24/09 ·
 * D-136 · DS-533).
 *
 * O nome de registro é link e abre a ficha em nova aba. Para isso a tela precisa do TIPO e
 * do ID do registro que o nome representa, e não só do rótulo. Este é o tipo único dessa
 * referência nos contratos: quem a lê no front é o `LinkDaEntidade`, pelo adaptador
 * `deReferencia` de `apps/web/src/componentes/link-da-entidade-regras.ts`.
 *
 * Os quinze tipos são as fichas que resolvem por uuid. A conta contábil fica de fora de
 * propósito: o Plano de Contas não tem ficha, e sim uma âncora (`#c-…`, pelo id, pelo código ou
 * pelo grupo da DRE; DS-604); o front a acrescenta ao próprio tipo (`TipoDaEntidade`).
 *
 * Nasce na Onda 2 (a base do item 09), para as frentes da Onda 4 lerem o MESMO tipo quando
 * os contratos ganharem as referências.
 */
export const tipoDeFicha = z.enum([
  'empresa',
  'contato',
  'negocio',
  'pedido',
  'campanha',
  'fornecedor',
  'conta_pagar',
  'colaborador',
  'tarefa',
  'orcamento_versao',
  'nf',
  'regra_comissao',
  'entidade_dv',
  'conta_bancaria',
  'portal_externo',
])
export type TipoDeFicha = z.infer<typeof tipoDeFicha>

/** Um registro com ficha: o tipo e o uuid dele. */
export const referenciaDeFicha = z.object({ tipo: tipoDeFicha, id: uuid })
export type ReferenciaDeFicha = z.infer<typeof referenciaDeFicha>

/**
 * Uma parte de venda (Cliente, Anunciante, Parceiro comissionado) com o nome que a tela
 * mostra e a ficha que ele abre: a empresa, ou o contato quando a parte é pessoa física.
 */
export const parteReferenciada = z.object({
  empresaId: uuid.nullable(),
  contatoId: uuid.nullable(),
  nome: z.string(),
})
export type ParteReferenciada = z.infer<typeof parteReferenciada>
